import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ DeliveryInfo: any }>;

export const DispatcDeliveryInfo: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutShipping/SaveDeliveryInfo",
        DeliveryInfo: props.parameter.DeliveryInfo,
    });
};

export const chain = [DispatcDeliveryInfo];

const SetDeliveryInfoValues = createHandlerChainRunner(chain, "SetDeliveryInfoValues");
export default SetDeliveryInfoValues;
